// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__MWsoB","container":"PrivacyPolicy_container__p9Z9M","list":"PrivacyPolicy_list__g6F7F"};